import InputField from "../form-input/InputField";

const LoginForm = (props: any) => {
    return (
        <>
            <InputField
                name="email"
                label="Email"
                type="email"
                register={props.register}
                error={props.errors.email}
                required={true}
            />
            <InputField
                name="password"
                label="Password"
                type="password"
                register={props.register}
                error={props.errors.password}
                required={true}
            />
        </>
    )
}

export default LoginForm;